import {isChangedDeviceSetting} from '@/selectors/deviceInfoSelector';

import {showValidateChangesModal} from './deviceSettingBusiness';

const {hidePopUp} = require('@/actions/modalActions');
const {INFO_AND_SUPPORT_ADDRESS, DEVICE_SETTING_ADDRESS} = require('@/constants/pcConstAppData');
const {navigateTo} = require('@/libs/appHelper');

// eslint-disable-next-line import/prefer-default-export
export function activeLicenseActivationModal() {
  return (dispatch, getState) => {
    const page = window.location.hash;

    const navigate = () => {
      navigateTo(INFO_AND_SUPPORT_ADDRESS);
      dispatch(hidePopUp());
    };

    if (page === DEVICE_SETTING_ADDRESS) {
      const isDeviceSettingChanged = isChangedDeviceSetting({...getState()});
      if (isDeviceSettingChanged) {
        dispatch(showValidateChangesModal(navigate));
      } else {
        navigate();
      }
    } else {
      navigate();
    }
  };
}
